import { render, staticRenderFns } from "./BatchFinancialTab.vue?vue&type=template&id=6470faf4"
import script from "./BatchFinancialTab.vue?vue&type=script&lang=js"
export * from "./BatchFinancialTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports